import React, {useState} from 'react';
import { useEnquiryCounts } from '../context/EnquiryContext';

const menuItems = [
  ['overview', 'grid', 'Overview'],
  ['distributors', 'briefcase', 'Distributor Enquiries'],
  ['super-stockists', 'users', 'Super Stockist Enquiries'],
  ['location-master', 'pin', 'Location Master'],
  ['mail-ids', 'mail', 'Map Email IDs'],
];

const paths = {
  grid: 'M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4zM14 14h6v6h-6z',
  briefcase: 'M9 6V4h6v2m-9 0h12a2 2 0 012 2v9a2 2 0 01-2 2H6a2 2 0 01-2-2V8a2 2 0 012-2zm-2 5h10M10 11v2h4v-2',
  users: 'M16 20v-2a4 4 0 00-4-4H6a4 4 0 00-4 4v2m7-10a4 4 0 100-8 4 4 0 000 8zm13 10v-2a4 4 0 00-3-3.87m-2-11.96a4 4 0 010 7.75',
  pin: 'M20 10c0 5-8 12-8 12S4 15 4 10a8 8 0 1116 0zm-8 3a3 3 0 100-6 3 3 0 000 6z',
  mail: 'M4 5h16v14H4zM4 7l8 6 8-6',
   trash: 'M3 6h18M8 6V4h8v2m2 0l-1 14H7L6 6m4 4v6m4-6v6',
  chevronDown: 'M6 9l6 6 6-6',
};

function Icon({ name }) {
  return <svg className="nav-icon" viewBox="0 0 24 24" aria-hidden="true"><path d={paths[name]} /></svg>;
}

const badgeKeys = { distributors: 'distributor', 'super-stockists': 'superStockist' };


function Sidebar({ collapsed, active, onSelect }) {
  const { counts } = useEnquiryCounts();

  const [binOpen, setBinOpen] = useState(active === 'super-stockist-bin' || active === 'distributor-bin');
  const binActive = active === 'super-stockist-bin' || active === 'distributor-bin';
  
  return (
    <aside className={`sidebar${collapsed ? ' collapsed' : ''}`}>
      <div className="sidebar-label">CHANNEL PARTNER</div>
      <nav aria-label="Channel partner navigation">
        <ul>
          {menuItems.map(([key, icon, label]) => (
            <li key={key}>
              <button
                className={active === key ? 'active' : ''}
                onClick={() => onSelect(key)}
                title={collapsed ? label : undefined}
              >
                <Icon name={icon} />
                <span>{label}</span>
                {badgeKeys[key] && counts[badgeKeys[key]] !== null && <em aria-label={`${counts[badgeKeys[key]]} enquiries`}>{counts[badgeKeys[key]]}</em>}

              </button>
            </li>
          ))}
          <li className="sidebar-dropdown">
            <button
              type="button"
              className={binActive ? 'active' : ''}
              onClick={() => setBinOpen(open => !open)}
              title={collapsed ? 'Bin' : undefined}
              aria-expanded={binOpen}
            >
              <Icon name="trash" />
              <span>Bin</span>
              {!collapsed && <span className={`sidebar-dropdown-arrow${binOpen ? ' open' : ''}`}><Icon name="chevronDown" /></span>}
            </button>
            {binOpen && !collapsed && <ul className="sidebar-submenu">
              <li><button type="button" className={active === 'super-stockist-bin' ? 'active' : ''} onClick={() => onSelect('super-stockist-bin')}><span>Super Stockist Enquiries Bin</span>{counts.superStockistBin !== null && <em aria-label={`${counts.superStockistBin} enquiries`}>{counts.superStockistBin}</em>}</button></li>
              <li><button type="button" className={active === 'distributor-bin' ? 'active' : ''} onClick={() => onSelect('distributor-bin')}><span>Distributor Enquiries Bin</span>{counts.distributorBin !== null && <em aria-label={`${counts.distributorBin} enquiries`}>{counts.distributorBin}</em>}</button></li>
            </ul>}
          </li>
        </ul>
      </nav>  
      {/* <div className="sidebar-help">
        <div className="help-icon">?</div>
        <div><strong>Need help?</strong><span>Visit support center</span></div>
      </div> */}
    </aside>
  );
}

export default Sidebar;
